import React from 'react';
import LegalPage from '@/components/LegalPage';

const ShippingPolicy = () => (
  <LegalPage
    title="Shipping Policy"
    effectiveDate="September 9, 2025"
    intro="At Raretto, we work hard to ensure your favorite chocolates reach you fresh, safe, and on time. Please read our Shipping Policy for details on how we process and deliver orders."
    sections={[
      {
        heading: '1. Order Processing Time',
        list: [
          'Orders are processed within 1–2 business days after confirmation.',
          'Orders placed on weekends or public holidays will be processed on the next working day.',
        ],
      },
      {
        heading: '2. Shipping Locations',
        list: [
          'We currently ship across India.',
          'For remote or non-serviceable pin codes, our team will contact you with alternative solutions.',
        ],
      },
      {
        heading: '3. Delivery Time',
        list: [
          'Standard delivery: 3–7 business days depending on your location.',
          'Metro cities may receive delivery faster, while remote areas may take longer.',
          'Delays may occur during festive seasons, sales, or due to unforeseen courier/logistics issues.',
        ],
      },
      {
        heading: '4. Shipping Charges',
        list: [
          'Free shipping on orders above ₹400.',
          'A flat shipping fee of ₹100 applies to orders below ₹400.',
          'Any applicable shipping charges will be displayed at checkout before payment.',
        ],
      },
      {
        heading: '5. Order Tracking',
        list: [
          'Once your order is shipped, you will receive an email/SMS with tracking details.',
          "You can track your package directly through the courier partner's website.",
        ],
      },
      {
        heading: '6. Packaging',
        list: [
          'All products are packed securely to ensure freshness and protection during transit.',
          'For sensitive items like chocolates, we may use temperature-resistant or insulated packaging (where applicable).',
        ],
      },
      {
        heading: '7. Delays & Responsibility',
        list: [
          'While we do our best to ensure timely delivery, Raretto is not liable for delays caused by courier partners, natural events, or circumstances beyond our control.',
          'If your order is delayed significantly, please reach out to our support team.',
        ],
      },
      {
        heading: '8. Contact Us',
        paragraphs: ['For any shipping-related questions, please contact:'],
        list: [
          'Rajasthan Trading Co. (Brand: Raretto), Worli, Mumbai, Maharashtra 400018',
          'Email: customersupport@raretto.com',
          'Phone: +91 91677 98999',
        ],
      },
    ]}
  />
);

export default ShippingPolicy;
